'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _AbstractReactComponent = require('./../AbstractReactComponent');

var _AbstractReactComponent2 = _interopRequireDefault(_AbstractReactComponent);

var _reactstrap = require('reactstrap');

var _ApiObjectSuggestField = require('./../field/ApiObjectSuggestField');

var _ApiObjectSuggestField2 = _interopRequireDefault(_ApiObjectSuggestField);

var _typyPrestupkuActions = require('./../actions/typyPrestupku-actions');

var TypyPrestupkuActions = _interopRequireWildcard(_typyPrestupkuActions);

var _utils = require('./../utils');

var _Utils = require('./../Utils2');

var _commons = require('../utils/commons');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getArea(props) {
    return props.area || "shared.typyPrestupku";
}

/**
 * Typ přestupku field
 * Suggest
 */

var TypPrestupkuField = function (_AbstractReactCompone) {
    (0, _inherits3.default)(TypPrestupkuField, _AbstractReactCompone);

    function TypPrestupkuField() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, TypPrestupkuField);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TypPrestupkuField.__proto__ || (0, _getPrototypeOf2.default)(TypPrestupkuField)).call.apply(_ref, [this].concat(args))), _this), _this.handleFilterSuggestions = function (value) {
            var _this$props = _this.props,
                typyPrestupku = _this$props.typyPrestupku,
                recidiva = _this$props.recidiva,
                platneKDatu = _this$props.platneKDatu;


            return new _promise2.default(function (resolve, reject) {
                if (typyPrestupku.fetched) {
                    var rows = (0, _utils.filterObjectsByPropertyFulltext)(typyPrestupku.rows, value, "popis");
                    if (typeof recidiva !== "undefined") {
                        rows = rows.filter(function (i) {
                            return i.recidiva === recidiva;
                        });
                    }
                    if (platneKDatu) {
                        var dateSpachani = (0, _commons.localUTCToDate)(platneKDatu);
                        rows = rows.filter(function (i) {
                            return !i.ucinnostDo || (0, _commons.localUTCToDate)(i.ucinnostDo) >= dateSpachani;
                        });
                    }
                    resolve(rows);
                } else {
                    resolve([]);
                }
            });
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(TypPrestupkuField, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var area = getArea(this.props);
            this.props.dispatch(TypyPrestupkuActions.fetchListIfNeeded(area));
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                typyPrestupku = _props.typyPrestupku,
                other = (0, _objectWithoutProperties3.default)(_props, ['typyPrestupku']);


            if (!typyPrestupku || !typyPrestupku.fetched) {
                return _react2.default.createElement(_reactstrap.Input, {
                    type: 'text',
                    disabled: true
                });
            }

            return _react2.default.createElement(_ApiObjectSuggestField2.default, (0, _extends3.default)({
                dropdown: true,
                filterSuggestions: this.handleFilterSuggestions,
                apiRequestDelay: 0,
                getItemValue: function getItemValue(item) {
                    return item ? item.popis : "";
                },
                renderSuggestion: function renderSuggestion(i, active, getItemValue) {
                    return _react2.default.createElement(
                        'div',
                        {
                            className: active ? "active" : "" },
                        i.popis
                    );
                }
            }, other));
        }
    }]);
    return TypPrestupkuField;
}(_AbstractReactComponent2.default);

TypPrestupkuField.PropTypes = {
    platneKDatu: _react2.default.PropTypes.object,
    area: _react2.default.PropTypes.string,
    recidiva: _react2.default.PropTypes.bool,
    addonsBefore: _Utils.COMPONENT_CHILDREN,
    addonsAfter: _Utils.COMPONENT_CHILDREN
};


function mapStateToProps(state, props) {
    var useArea = getArea(props);
    var stateStore = (0, _utils.storeFromArea)(state, useArea, false);

    return {
        typyPrestupku: stateStore
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(TypPrestupkuField);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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